import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[portalValidationError]',
  standalone: false,
})
export class ValidationErrorDirective {
  @Input()
  portalValidationError: string;

  constructor(public templateRef: TemplateRef<any>) {}
}
